import { Box, ListItemSelect, Divider, Thumbnail, Text } from '@wix/design-system';
import React, { useContext, useMemo } from 'react';
import { RicosContext } from 'ricos-context';
import { TEXT_LIST_OPTION, IMAGE_AND_LIST_OPTION, IMAGE_GRID_OPTION } from '../../dataHooks.js';
import { PRESET_TYPE } from './preset-data.js';
import { s as styleInject } from '../../style-inject.es-e7b07dd7.js';
import { ListPollIcon } from '../../assets/icons/ListPollIcon.js';
import { WithImagePollIcon } from '../../assets/icons/WithImagePollIcon.js';
import { GridPollIcon } from '../../assets/icons/GridPollIcon.js';
import 'lodash';
import 'ricos-schema';
import 'wix-rich-content-editor-common';
import '../../defaults.js';
import '../../helpers.js';
import 'ricos-schema/next';
import 'wix-rich-content-common/libs/imageUtils';

var css_248z = ".K3Wt2{--wds-color-blue-250:#a6d0ff}";
var classes = {"presetPicker":"K3Wt2"};
styleInject(css_248z);

const PresetPicker = ({ onPollAdd }) => {
  const { t, isMobile } = useContext(RicosContext);
  const dataSource = useMemo(
    () => [
      {
        value: PRESET_TYPE.LIST,
        label: t("Poll_Presets_Popup_Option_TextList"),
        icon: ListPollIcon,
        dataHook: TEXT_LIST_OPTION
      },
      {
        value: PRESET_TYPE.LIST_WITH_IMAGE,
        label: t("Poll_Presets_Popup_Option_TextListAndMainImage"),
        icon: WithImagePollIcon,
        dataHook: IMAGE_AND_LIST_OPTION
      },
      {
        value: PRESET_TYPE.GRID,
        label: t("Poll_Presets_Popup_Option_ImagesGrid"),
        icon: GridPollIcon,
        dataHook: IMAGE_GRID_OPTION
      }
    ],
    [t]
  );
  const Component = isMobile ? PresetPickerVertical : PresetPickerHorizontal;
  return /* @__PURE__ */ React.createElement(Component, { dataSource, onPollAdd });
};
const PresetPickerVertical = ({ dataSource, onPollAdd }) => {
  return /* @__PURE__ */ React.createElement(Box, { direction: "vertical" }, dataSource.map((item) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    ListItemSelect,
    {
      key: item.value,
      title: item.label,
      dataHook: item.dataHook,
      onClick: () => onPollAdd(item.value),
      size: "medium",
      prefix: /* @__PURE__ */ React.createElement(
        "div",
        {
          style: {
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            border: "1px solid #d3d3d3",
            marginBlock: "10px"
          }
        },
        /* @__PURE__ */ React.createElement(item.icon, null)
      )
    }
  ), /* @__PURE__ */ React.createElement(Divider, null))));
};
const PresetPickerHorizontal = ({ dataSource, onPollAdd }) => {
  return /* @__PURE__ */ React.createElement(Box, { align: "space-between", direction: "horizontal", className: classes.presetPicker }, dataSource.map((item) => /* @__PURE__ */ React.createElement(
    Thumbnail,
    {
      key: item.value,
      size: "small",
      dataHook: item.dataHook,
      title: /* @__PURE__ */ React.createElement(Text, { size: "tiny" }, item.label),
      onClick: () => {
        onPollAdd(item.value);
      },
      image: /* @__PURE__ */ React.createElement(
        "div",
        {
          style: {
            border: "1px solid #d3d3d3"
          }
        },
        /* @__PURE__ */ React.createElement(item.icon, null)
      )
    }
  )));
};

export { PresetPicker };
//# sourceMappingURL=preset-picker.js.map
